import { parseBoostCalloutBannerContent } from "./boostCalloutBanner";
import { parseBoostMultiplierSharedContent } from "./boostMultiplierShared";

export type ContentType = keyof typeof contentParsersMap;

export const contentParsersMap = {
  boostCalloutBanner: parseBoostCalloutBannerContent,
  boostMultiplierSharedV2: parseBoostMultiplierSharedContent,
};
